import ArticleTemplate from "../components/ArticleTemplate";
import { articles } from "@/mocks/articles";

export default function ArticleBezpieczenstwo() {
  return <ArticleTemplate article={articles[4]} />;
}